/**
 * chatEngineMark — the one name for "the chat engine has mounted".
 *
 * ChatEngineLoader.tsx stamps it with performance.mark() the moment the engine
 * lands — from that frame the closed chat bar and the California disclosure
 * line under it are on the page. src/reportWebVitals.ts reads it back and sends
 * it from real visitors as one more first-party metric beside the five Core
 * Web Vitals, so "how long until the chat arrives?" has a field answer, not
 * only a lab one (PR-S3, 2026-09-22).
 *
 * A zero-import leaf on purpose: the reporter must never pull the loader (or
 * anything the loader pulls) just to learn a string.
 */

/** The User Timing mark the loader stamps when the engine has mounted. */
export const CHAT_ENGINE_MOUNTED_MARK = 'prest0:chat-engine-mounted';

/**
 * The metric name the field reporter sends the mark under. The server's
 * allow-list (functions/src/telemetry/webVitalsSchema.ts ALLOWED_METRICS) must
 * carry the same literal — the two trees cannot import each other, so
 * tests/landing/chatReadyVital.test.ts pins the pair by reading both sources.
 */
export const CHAT_READY_METRIC = 'CHAT_READY';
